import request from '@/config/axios'

// #region api-apm
//获取项目分组列表
export const GetProjects = (data) => {
  return request.get({
    url: '/api-apm/api/v1/project',
    params: data,
  })
}
// 获取项目分组下的资产组列表
export const GetAssetListByProject = (data) => {
  return request.get({
    url: '/api-apm/api/v1/project/groups',
    params: data
  })
}

//新增项目分组
export const AddProject = (data) => {
  return request.post({
    url: '/api-apm/api/v1/project',
    data: data,
  })
}
//编辑项目分组
export const UpdateProject = (data) => {
  return request.put({
    url: '/api-apm/api/v1/project',
    data: data,
  })
}
//删除项目分组
export const DeleteProjectById = (id) => {
  return request.delete({
    url: '/api-apm/api/v1/project',
    params: {id:id},
  })
}
//新增操作日志
export const AddOperateLog = (data) => {
  return request.post({
    url: '/api-apm/api/v1/operate/log',
    data: data,
  })
}

// 获取资产组列表
export const GetAssetList = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/list',
    params: data
  })
}
//获取资产组详情
export const GetAssetDetail = (id) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/byid',
    params: {
      id:id
    }
  })
}
//获取资产组导出列表
export const GetAssetExportList = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/export/list',
    params: data
  })
}
//获取资产组新增导出任务
export const AddAssetExport = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/group/export',
    data: data
  })
}

//资产组导入
export const ImportAsset = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/group/import',
    data: data
  })
}
export const GetImportAssetStatus = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/import/status',
    params: data
  })
}
// 中止导入任务
export const CancelImportAsset = () => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/import/cancel',
  })
}
//资产组导出文件
export const DownloadAssetFile = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/export/file',
    params: data,
    responseType: "blob",
  })
}
//删除资产组导出任务文件
export const DeleteAssetFile = (data) => {
  return request.delete({
    url: '/api-apm/api/v1/asset/group/export/file',
    params: data
  })
}
//新增资产组
export const AddAsset = (data) => {
    return request.post({
      url: '/api-apm/api/v1/asset/group',
      data: data
    })
  }
//更新资产组
export const UpdateAsset = (data) => {
  return request.put({
    url: '/api-apm/api/v1/asset/group',
    data: data
  })
}  
//删除资产组
export const DeleteAssetById = (data) => {
    return request.delete({
        url: '/api-apm/api/v1/asset/group/clear',
        params: data,
        data:data
    })
}
//获取模板列表
export const GetTemps = (params) => {
  return request.get({
      url: '/api-apm/api/v1/template',
      params: params
  })
}
//获取资产组模板列表
export const GetTempByGroup = (params) => {
  return request.get({
      url: '/api-apm/api/v1/template/bygroup',
      params: params
  })
}
//获取资产节点byid
export const GetAssetNodeById = (nodeId,withOutImage=true) => {
  return request.get({
      url: '/api-apm/api/v1/asset/node/byid',
      params: {
        id: nodeId,
        withOutImage: withOutImage
      }
  })
}
//修改资产节点
export const PutAssetNode = (data) => {
  return request.put({
      url: '/api-apm/api/v1/asset/node',
      data: data
  })
}
// 修改节点模板
export const ChangeTemplate = (nodeId,templateId,retain=true) => {
  return request.post({
      url: '/api-apm/api/v1/asset/node/changetemplate',
      data: {
        nodeId: nodeId,
        templateId: templateId,
        retain: retain
      }
  })
}
// 获取设备图片
export const GetImg = (id,ids=[]) => {
  return request.get({
      url: '/api-apm/api/v1/image',
      params: {id:id,ids:ids}
  })
}

//获取资产组显示类型 tree/list 
export const SetGroupDisplay = (groupId,displayMode) => {
  return request.post({
    url: '/api-apm/api/v1/asset/group/display',
    data: {
      groupId:groupId,
      displayMode:displayMode
    }
  })
}

export const GetGroupDisplay = (groupId) => {
  return request.get({
    url: '/api-apm/api/v1/asset/group/display',
    params: {
      groupId:groupId
    }
  })
}
//新增节点
export const AddNode = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/node',
    data: data
  })
}
//复制节点
export const CopyNode = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/node/copy',
    data: data
  })
}
//深复制节点
export const DeepCopyNode = (data) => {
  return request.post({
    url: '/api-apm/api/v1/asset/node/copy/branch',
    data: data
  })
}
//深复制节点
export const DeepCopyNodeStatus = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/copy/branch/status',
    params: data
  })
}
export const DeleteNodeById = (data) => {
  return request.delete({
    url: '/api-apm/api/v1/asset/node/byid',
    params: data
  })
}
export const DeleteNodeCascade = (id) => {
  return request.delete({
    url: '/api-apm/api/v1/asset/node/cascade',
    params: {
      nodeId:id,
      cascade:true
    }
  })
}
//获取资产组根节点
export const GetRootNode = async (data) => {
  try{
    const res = await request.get({
      url: '/api-apm/api/v1/asset/node/root',
      params: data
    })
    if(res){
      return res 
    }
  }catch(error){ }
}

//获取资产组所有节点
export const GetNodeList = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/list',
    params: data
  })
}

//更新多个资产节点
export const UpdateNodeList = (data) => {
  return request.put({
    url: '/api-apm/api/v1/asset/node/list',
    data: data
  })
}
//获取根据NodeID获取子节点
export const GetChildNodes = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/progeny',
    params: data
  })
}
//查询Group下的节点
export const GetNodesByGroup = params => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/bygroup',
    params: params
  })
}
//获取根据NodeID获取子节点分页
export const GetChildNodesByPage = (data) => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/progeny/page',
    params: data
  })
}

// 获取节点属性
export const GetNodeProperty = (params) => {
  return request.get({
      url: '/api-apm/api/v2/node/property',
      params: params
  })
}
// 批量更新节点属性
export const UpdateNodePropertys = (data) => {
  return request.post({
      url: '/api-apm/api/v2/node/property/list',
      data: data
  })
}
export const DelNodeProperty = (params) => {
  return request.delete({
      url: '/api-apm/api/v2/node/property',
      params: params
  })
}
export const AddNodeProperty = (data) => {
  return request.post({
      url: '/api-apm/api/v2/node/property',
      data: data
  })
}
export const UpdateNodePropertyByid = (data) => {
  return request.put({
      url: '/api-apm/api/v2/node/property/byid',
      data: data
  })
}
// 获取node的参数项
export const GetNodeCalcItems = (params) => {
  return request.get({
      url: '/api-apm/api/v1/node/property/calcItems',
      params: params
  })
}
// 获取节点组件
export const GetNodeComponent = (params) => {
  return request.get({
      url: '/api-apm/api/v2/node/component',
      params: params
  })
}

export const GetEdgeInputs = params => {
  return request.get({
    url: '/api-apm/api/v2/edge/input',
    params: params
  })
}

export const PutEdgeInputs = data => {
  return request.put({
    url: '/api-apm/api/v2/edge/input',
    data: data
  })
}

export const GetIotSenseDevice = params => {
  return request.get({
    url: '/api-apm/api/v1/iot/sense/device',
    params: params
  })
}

export const GetIotSenseTagInfo = params => {
  return request.get({
    url: '/api-apm/api/v1/iot/sense/taginfo',
    params: params
  })
}

export const GetEnum = params => {
  return request.get({
    url: '/api-apm/api/v1/enum',
    params: params
  })
}

export const AddEnum = data => {
  return request.post({
    url: '/api-apm/api/v1/enum',
    data: data
  })
}

export const UpdateEnum = data => {
  return request.put({
    url: '/api-apm/api/v1/enum',
    data: data
  })
}

export const DeleteEnum = data => {
  return request.delete({
    url: '/api-apm/api/v1/enum',
    data: data
  })
}

export const GetLabel = params => {
  return request.get({
    url: '/api-apm/api/v1/label',
    params: params
  })
}

export const AddLabel = data => {
  return request.post({
    url: '/api-apm/api/v1/label',
    data: data
  })
}

export const UpdateLabel = data => {
  return request.put({
    url: '/api-apm/api/v1/label',
    data: data
  })
}

export const DeleteLabel = id => {
  return request.delete({
    url: `/api-apm/api/v1/label?id=${id}`
  })
}

export const GetAlarmCategoryGroup = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/group',
    params: params
  })
}

export const GetAlarmCategoryList = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/list',
    params: params
  })
}

export const AddAlarmCategory = data => {
  return request.post({
    url: '/api-apm/api/v1/alarmcategory',
    data: data
  })
}

export const UpdateAlarmCategory = data => {
  return request.put({
    url: '/api-apm/api/v1/alarmcategory',
    data: data
  })
}

export const DeleteAlarmCategory = id => {
  return request.delete({
    url: `/api-apm/api/v1/alarmcategory?id=${id}`
  })
}

export const GetAlarmprocess = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmprocess',
    params: params
  })
}

export const AddAlarmprocess = data => {
  return request.post({
    url: '/api-apm/api/v1/alarmprocess',
    data: data
  })
}

export const UpadteAlarmprocess = data => {
  return request.put({
    url: '/api-apm/api/v1/alarmprocess',
    data: data
  })
}

export const DelAlarmprocess = id => {
  return request.delete({
    url: `/api-apm/api/v1/alarmprocess?id=${id}`
  })
}

export const CheckNodeAlarmPropertyName = (data) => {
  return request.post({
      url: '/api-apm/api/v2/node/property/alarm/check',
      data: data
  })
}

export const GetTempComponent = (params) => {
  return request.get({
      url: '/api-apm/api/v1/template/component',
      params: params
  })
}

export const AddTempComponent = (data) => {
  return request.post({
      url: '/api-apm/api/v1/template/component',
      data: data
  })
}

export const GetComponentByName = (name) => {
  return request.get({
      url: '/api-apm/api/v1/component/byname',
      params: {
        name: name
      }
  })
}

export const GetTempProperty = (params) => {
  return request.get({
      url: '/api-apm/api/v1/template/property',
      params: params
  })
}
export const UpdateTempPropertList = (data) => {
  return request.put({
      url: '/api-apm/api/v1/template/property/list',
      data: data
  })
}

export const GetAssetNodeByGroupTemplate = params => {
  return request.get({
    url: '/api-apm/api/v1/asset/node/bygrouportemplate',
    params: params
  })
}

export const TemplateSync = data => {
  return request.post({
    url: '/api-apm/api/v1/template/sync',
    data: data
  })
}

export const GetTempSyncStatus = params => {
  return request.get({
    url: '/api-apm/api/v1/template/sync/status',
    params: params
  })
}

export const AssetNodeSort = data => {
  return request.post({
    url: '/api-apm/api/v1/asset/node/sort',
    data: data
  })
}

export const getCategoryByNode = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/bygroupornode',
    params: params
  })
}

export const getCategoryGroup = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/group',
    params: params
  })
}

export const getCategoryByRootName = params => {
  return request.get({
    url: '/api-apm/api/v1/alarmcategory/list',
    params: params
  })
}
export const getCategoryByRootNames = data => {
  return request.post({
    url: '/api-apm/api/v1/alarmcategory/list/by/rootnames',
    data
  })
}

export const getTemplateById = params => {
  return request.get({
    url: '/api-apm/api/v1/template/byid',
    params: params
  })
}

export const getRawDataListV1 = data => {
  return request.post({
    url: '/api-apm/api/v1/hist/raw/data',
    data: data
  })
}

export const getAssetGroupByProject = data => {
  return request.post({
    url: '/api-apm/api/v1/asset/group/byproject',
    data: data
  })
}
// #endregion api-apm

// #region alarm-process
export const getEventProcessLogList = logId => {
  return request.get({
    url: '/alarm-process/api/v1/event/process/log',
    params: {
      logId :logId
    }
  })
}

export const addEventProcessLog = data => {
  return request.post({
    url: '/alarm-process/api/v1/event/process',
    data: data
  })
}

export const deleteProcessEvent = data => {
  return request.delete({
    url: '/alarm-process/api/v1/event/log',
    data: data
  })
}

export const updateEvent = data => {
  return request.put({
    url: '/alarm-process/api/v1/event/log',
    data: data
  })
}

export const getEventTimes = data => {
  return request.post({
    url: '/alarm-process/api/v1/event/times',
    data: data
  })
}

export const getEventTimesMulti = data => {
  return request.post({
    url: '/alarm-process/api/v1/event/times/multi',
    data: data
  })
}

export const getEventList = data => {
  return request.post({
    url: '/alarm-process/api/v1/event/list',
    data: data,
    timeout: 20000
  })
}

export const getEventListMulti = data => {
  return request.post({
    url: '/alarm-process/api/v1/event/list/multi',
    data: data,
    timeout: 20000
  })
}
// #endregion alarm-process

